import { Typography } from '@mui/material';
import AccordionMui from '@mui/material/Accordion';
import AccordionSummaryMui from '@mui/material/AccordionSummary';
import AccordionDetailsMui from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ExpandablePanelProps } from 'components/shared/surfaces/ExpandablePanel/ExpandablePanel.types';
import React, { FC } from 'react';
import { withStyles } from 'tss-react/mui';

export const Accordion = withStyles(AccordionMui, {
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 'auto',
    },
  },
});

export const AccordionSummary = withStyles(AccordionSummaryMui, {
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid transparent',
    marginBottom: -1,
    minHeight: 50,
    '&.Mui-expanded': {
      minHeight: 50,
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
    },
  },
  content: {
    '&.Mui-expanded': {
      margin: '12px 0',
    },
  },
});

export const AccordionDetails = withStyles(AccordionDetailsMui, (theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}));

export const ExpandablePanel: FC<ExpandablePanelProps> = ({ title, className, defaultExpanded, children }) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={className}>{children}</AccordionDetails>
    </Accordion>
  );
};
